import React, { useState, useEffect } from 'react';

const ChristmasPopup = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Set the date when the popup should stop showing (January 5, 2026 at 08:00)
    const endDate = new Date('2026-01-05T08:00:00');
    const currentDate = new Date();

    // Only show popup if current date is before the end date
    if (currentDate <= endDate) {
      // Small delay to ensure smooth appearance
      setTimeout(() => {
        setVisible(true);
      }, 500);
    }
  }, []);

  const handleClose = () => {
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm animate-fade-in">
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full mx-4 overflow-hidden animate-scale-in">
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 z-10 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Close"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Christmas Photo */}
        <div className="w-full">
          <img
            src="/assets/InfiChristmas.png"
            alt="Merry Christmas"
            className="w-full h-auto object-cover"
            onError={(e) => {
              // Fallback if image doesn't exist
              e.target.style.display = 'none';
              e.target.nextElementSibling.style.display = 'flex';
            }}
          />
          {/* Fallback if image doesn't exist */}
          <div className="hidden w-full h-64 bg-gradient-to-br from-red-500 to-green-500 flex items-center justify-center">
            <span className="text-white text-2xl font-bold">🎄 Merry Christmas! 🎄</span>
          </div>
        </div>

        {/* Happy Holidays Button */}
        <div className="p-6 bg-gradient-to-br from-red-50 to-green-50">
          <button
            onClick={handleClose}
            className="w-full bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-bold text-lg py-4 px-8 rounded-lg shadow-lg hover:shadow-xl transition-all transform hover:scale-105 active:scale-95"
          >
            Happy Holidays - Весели Празници - Joyeuses Fêtes - Buone Feste - Frohe Feiertage
          </button>
          <p className="text-center text-xs text-gray-600 mt-3">
            click to continue to website
          </p>
        </div>
      </div>
    </div>
  );
};

export default ChristmasPopup;
